import classNames from 'classnames';
import styles from './EstablishmentCard.module.css';
import { EstablishmentCardProps } from './EstablishmentCard.interface';
import { EnterpriseCorporationInsuranceImage } from 'components/images';

export const EstablishmentCard = ({
    establishment: {
        APET700_establishment_activity: nafCode,
        address: { city, row4, zip_code },
        establishment_activity_label: nafLabel,
        company_name: name,
    },
}: EstablishmentCardProps): JSX.Element => {
    return (
        <div className={ classNames(styles.host) }>
            <div className={ classNames(styles.header) }>
                <EnterpriseCorporationInsuranceImage />

                <span className={ classNames(styles.name) }>
                    { name }
                </span>
            </div>

            { (nafCode || nafLabel) && (
                <div>
                    <span>NAF : </span>
                    { nafCode && <strong>{ nafCode }</strong> }
                    { nafCode && nafLabel && ', ' }
                    { nafLabel }
                </div>
            ) }

            <div>
                Adresse :{ ' ' }
                { row4 && <strong>{ `${ row4 }, ` }</strong> }
                { city } ({ zip_code })
            </div>
        </div>
    );
};
